var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('div',{staticClass:"sk-double-bounce",style:({ width: _vm.width, height: _vm.height })},[_c('div',{staticClass:"sk-child sk-double-bounce1"}),_c('div',{staticClass:"sk-child sk-double-bounce2"})])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }